
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatCedula } from "@/utils/HelperFunctions";
import User from "@/models/User";

@Component
export default class NameAndCedula extends Vue {
    @Prop() private user!: User;

    public formatUserCedula(cedula: string): string {
        return formatCedula(cedula);
    }
}
